document.addEventListener('DOMContentLoaded', function () {
  /**
  * page compare product pagination start
 */
  const pageCompareProducts = document.querySelector('.page-product-compare-product');
  if (pageCompareProducts && window.innerWidth < 799) {
    const table = pageCompareProducts.querySelector('table');
    const rows = table.querySelectorAll('tr');
    const singleItemWidth = rows[0].children[1].clientWidth - 20;
    let currentIndex = 0;
    const productNum = rows[0].children.length - 1
    // const totalPages = Math.ceil(productNum / 2);
    const totalPages = Math.ceil(productNum / 1);
    let paginationContainer = document.createElement('div');
    paginationContainer.className = 'pagination-compare';
    for (let i = 0; i < totalPages; i++) {
      const pageButton = document.createElement('div');
      pageButton.className = 'page-dot';
      if (i === 0) {
        pageButton.classList.add('active')
      }
      paginationContainer.appendChild(pageButton);
    }
    pageCompareProducts.appendChild(paginationContainer);
    pageCompareProducts.addEventListener('scroll', function() {
      const scrollPosition = pageCompareProducts.scrollLeft;
      const elementIndex = Math.floor(scrollPosition / singleItemWidth);
      
      // let newIndex = elementIndex % 2 === 0 ? (elementIndex / 2) + 1 : Math.floor((elementIndex / 2) + 1.5);
      let newIndex = elementIndex + 1;
      if (newIndex !== currentIndex) {
        currentIndex = newIndex;
        updatePageIndex(currentIndex);
      }
    });

    function updatePageIndex(index) {
      const buttons = paginationContainer.querySelectorAll('.page-dot');
      buttons.forEach((button, i) => {
        if (i+1 === index) {
          button.classList.add('active');
        } else {
          button.classList.remove('active');
        }
      });
    }
  } 
  /**
   * page compare product pagination end 
  */

  /**
   * link list start
  */
 const linklistWrapper = document.querySelector('.linklist-wrapper');
 if (linklistWrapper) {
   const links = document.querySelectorAll('.linklist-wrapper .linklist-link');
   const sections = Array.from(links).map(link => {
     const id = link.getAttribute('href').replace('#', '');
     return document.getElementById(id);
   });
 
   // when click the anchor, highlight
   links.forEach(link => {
     link.addEventListener('click', function (e) {
       e.preventDefault(); // 阻止默认行为
       const targetId = this.getAttribute('href').replace('#', '');
       const targetSection = document.getElementById(targetId);
       if (targetSection) {
         window.scrollTo({
           top: targetSection.parentElement.offsetTop - linklistWrapper.offsetHeight,
           behavior: 'smooth'
         });
       }
       links.forEach(l => l.classList.remove('active'));
       this.classList.add('active');
     });
   });
 
   // when scroll, highlight the anchor and sticky
   let scrollTimeout;
   const headerHeight = document.querySelector('.shopify-section-group-header-group .header__wrapper').offsetHeight;
   linklistWrapper.parentElement.style.top = headerHeight - 1 + 'px';
   
   let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const newHeaderHeight = document.querySelector('.shopify-section-group-header-group .header__wrapper').offsetHeight;
        linklistWrapper.parentElement.style.top = newHeaderHeight - 1 + 'px';
      }, 100);
    });

   window.addEventListener('scroll', function () {
     clearTimeout(scrollTimeout);
     scrollTimeout = setTimeout(() => {
 
       //  link when scroll, highlight the link corresponding to the current section 
       let currentIndex = 0;
       sections.forEach((section, i) => {
         if (section && window.scrollY >= section.parentElement.offsetTop - linklistWrapper.offsetHeight - 10) {
           currentIndex = i;
         }
       });
       links.forEach(l => l.classList.remove('active'));
       if (links[currentIndex]) {
         links[currentIndex].classList.add('active');
       }
     }, 100); // 防抖延迟
   });
 }
 /**
  * link list end
 */

 /**
  * Listen for form submission success event start
 */
 const formSummerNewsletter = document.getElementById('summer-newsletter');
 if (formSummerNewsletter) {
   const couponContainer = document.querySelector('.summer-coupon-container');
   if (window.location.hash === '#summer-newsletter') {
     couponContainer.style.display = 'flex';
     couponContainer.style.opacity = '1';
   }
   formSummerNewsletter.addEventListener('submit', function(e) {
     // Show coupon container
     if (couponContainer) {
       couponContainer.style.display = 'flex';
       // Add animation effect
       couponContainer.style.opacity = '0';
       setTimeout(() => {
         couponContainer.style.opacity = '1';
         couponContainer.style.transition = 'opacity 0.3s ease';
       }, 100);
     }
   });
 }
 /**
  * Listen for form submission success event end
 */
});

/* ============================================
   VIDEO SECTION - Fullscreen Functionality
   ============================================ */

   (function() {
    let overlay = null;
    let closeBtn = null;
    let escHandler = null;
    
    const addAutoplay = (url) => url + (url.includes('?') ? '&autoplay=1' : '?autoplay=1');
    
    const cleanup = () => {
      if (escHandler) {
        document.removeEventListener('keydown', escHandler);
        escHandler = null;
      }
      if (closeBtn) {
        closeBtn.remove();
        closeBtn = null;
      }
      if (overlay) {
        overlay.remove();
        overlay = null;
      }
    };
    
    const getVideoSource = (button) => {
      const customSrc = button.getAttribute('data-fullscreen-video-src');
      if (customSrc) return customSrc;
      
      const section = button.closest('.shopify-section--video');
      if (!section) return null;
      
      const videoMedia = section.querySelector('video-media');
      if (!videoMedia) return null;
      
      const video = videoMedia.querySelector('video') || videoMedia.querySelector('iframe');
      if (!video) return null;
      
      return video.tagName === 'VIDEO' ? (video.src || video.querySelector('source')?.src) : video.src;
    };
    
    const createVideoElement = (src) => {
      const isExternal = src.includes('youtube.com') || src.includes('vimeo.com');
      
      if (isExternal) {
        const iframe = document.createElement('iframe');
        iframe.className = 'video-page-fullscreen-overlay__iframe';
        iframe.src = addAutoplay(src);
        iframe.allow = 'autoplay; encrypted-media';
        iframe.allowFullscreen = true;
        return iframe;
      }
      
      const video = document.createElement('video');
      video.className = 'video-page-fullscreen-overlay__video';
      video.src = src;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      return video;
    };
    
    document.addEventListener('click', (e) => {
      const button = e.target.closest('[data-video-fullscreen]');
      if (!button) return;
      
      e.preventDefault();
      cleanup();
      
      const videoSrc = getVideoSource(button);
      if (!videoSrc) return;
      
      // Create overlay
      overlay = document.createElement('div');
      overlay.className = 'video-page-fullscreen-overlay active';
      
      const container = document.createElement('div');
      container.className = 'video-page-fullscreen-overlay__container';
      container.appendChild(createVideoElement(videoSrc));
      
      // Create close button
      closeBtn = document.createElement('button');
      closeBtn.className = 'video-page-fullscreen-overlay__close';
      closeBtn.type = 'button';
      closeBtn.innerHTML = '×';
      closeBtn.setAttribute('aria-label', 'Close fullscreen video');
      closeBtn.onclick = cleanup;
      
      // Add to DOM
      overlay.appendChild(container);
      document.body.appendChild(overlay);
      document.body.appendChild(closeBtn);
      
      // ESC key support
      escHandler = (e) => e.key === 'Escape' && cleanup();
      document.addEventListener('keydown', escHandler);
    });
  })();
  
  /* ============================================
     END: VIDEO SECTION
     ============================================ */
  
  /* ============================================
     PRODUCT GALLERY - Side Arrows Initial State
     ============================================ */
  
  /**
   * Set initial disabled state for product gallery side arrows
   * Ensures left arrow is disabled on first slide at page load
   */
  (function() {
    const initArrowsState = () => {
      const galleries = document.querySelectorAll('.product-gallery--side-arrows');
      
      galleries.forEach(gallery => {
        const carousel = gallery.querySelector('media-carousel');
        const sideArrows = gallery.querySelector('.product-gallery__side-arrows');
        
        if (!carousel || !sideArrows) return;
        
        const prevButton = sideArrows.querySelector('[is="prev-button"]');
        const nextButton = sideArrows.querySelector('[is="next-button"]');
        
        if (!prevButton || !nextButton) return;
        
        // Get current index and total items
        const currentIndex = carousel.selectedIndex || 0;
        const totalItems = carousel.items.length;
        
        // Set initial disabled state
        if (currentIndex === 0) {
          prevButton.disabled = true;
        }
        if (currentIndex === totalItems - 1) {
          nextButton.disabled = true;
        }
      });
    };
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initArrowsState);
    } else {
      // DOM already loaded
      initArrowsState();
    }
    
    // Support for theme editor
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', initArrowsState);
    }
  })();
  
  /* ============================================
     END: PRODUCT GALLERY
     ============================================ */
  
  /* ============================================
     BLOG DROPDOWN FILTER
     ============================================ */
  
  /**
   * Blog dropdown filter functionality for recipe pages
   */
  (function() {
    let dropdownListButtons = document.querySelectorAll('.dropdown-list .dropdown-list_btn');
    if (dropdownListButtons.length > 0) {
      dropdownListButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          let dropdownContent = this.nextElementSibling;
          let dropdownContentDisplay = dropdownContent.style.display;
          let dropdownListContent = document.querySelectorAll('.dropdown-list .dropdown-list_content');
          if (dropdownListContent) {
            dropdownListContent.forEach(function (content) {
              content.style.display = 'none';
            });
          }
          dropdownContent.style.display = dropdownContentDisplay === 'block' ? 'none' : 'block';
          event.stopPropagation();
        });
      });
    }
    
    let dropdownListItems = document.querySelectorAll('.dropdown-list .dropdown-list_item');
    if (dropdownListItems.length > 0) {
      dropdownListItems.forEach(function (item) {
        item.addEventListener('click', function (event) {
          let value = event.target.dataset.value;
          let labelElement = event.target.closest('.dropdown-list').querySelector('.dropdown-list_btn span');
          let optionalFirst = event.target.textContent;
          labelElement.textContent = optionalFirst;
          let find = "/blogs/recipes/tagged/" + value;
          window.location.href = find;
        });
      });
    }
    
    document.addEventListener('click', function() {
      if (document.querySelectorAll('.dropdown-list_content')) {
        document.querySelectorAll('.dropdown-list_content').forEach(function(content) {
          content.style.display = 'none';
        });
      }
    });
  })();
  
  /* ============================================
     END: BLOG DROPDOWN FILTER
     ============================================ */
  
  /* ============================================
     REZEPTE SEARCH
     ============================================ */
  
  /**
   * Recipe search functionality
   */
  document.addEventListener('DOMContentLoaded', function () {
    const searchForm = document.getElementById('main-search-form');
    const pathname = window.location.pathname;
    
    if (searchForm && pathname.includes('/blogs/recipes')) {
      const urlObj = new URL(window.location.href);
      const params = new URLSearchParams(urlObj.search);
      const qValue = params.get('vs');
      const vsInput = document.querySelector('input[name="vs"]');
      
      if (vsInput) {
        vsInput.value = qValue || '';
      }
      
      if (qValue) {
        const recipeContainer = document.querySelector('.blog-recipe__container');
        if (recipeContainer) {
          recipeContainer.innerHTML = '';
        }
        
        let paginationPoints = document.querySelectorAll('.pagination-point');
        if (paginationPoints) {
          paginationPoints.forEach(function(element) {
            element.style.display = 'none';
          });
        }
        
        let searchQuery = qValue;
        if (pathname.includes('/blogs/recipes/tagged/')) {
          let searchTag = pathname.split('tagged/')[1];
          searchQuery = searchQuery + ' tag:' + searchTag;
        }
        
        fetch('/search?q=' + encodeURIComponent(searchQuery) + '&type=article&options[prefix]=last')
          .then(function (response) {
            return response.text();
          })
          .then(function (data) {
            const html = new DOMParser().parseFromString(data, 'text/html');
            const targetElement = document.querySelector('.blog-recipe__container');
            const sourceElement = html.querySelector('.blog-recipe__container');
  
            if (targetElement && sourceElement) {
              var items = sourceElement.querySelectorAll('.recipe-article-content');
              items.forEach(function(item) {
                var onclickAttr = item.getAttribute('onclick') || '';
                if (!onclickAttr.includes('/blogs/recipes/')) {
                  item.remove();
                }
              });
  
              var remaining = sourceElement.querySelectorAll('.recipe-article-content');
              if (remaining.length === 0) {
                targetElement.innerHTML = '<div class="empty-state"><div class="prose"><h1 class="h4">No results found.</h1></div></div>';
              } else {
                targetElement.replaceWith(sourceElement);
              }
            } else if (targetElement && !!qValue) {
              targetElement.innerHTML = '<div class="empty-state"><div class="prose"><h1 class="h4">No results found.</h1></div></div>';
            }
          });
      }
      
      searchForm.addEventListener('submit', function (event) {
        event.preventDefault();
        let searchQuery = document.querySelector('input[name="vs"]').value;
  
        if (searchQuery) {
          var searchParams = new URLSearchParams(window.location.search);
          searchParams.set('vs', searchQuery);
          var newUrl = window.location.pathname + '?' + searchParams.toString();
          window.location.href = newUrl;
        } else {
          window.location.href = window.location.pathname;
        }
      });
    }
  });
  
  /* ============================================
     END: REZEPTE SEARCH
     ============================================ */
  
  /* ============================================
     RECIPE ARTICLE - Print Functionality
     ============================================ */
  
  /**
   * Print recipe article content using a hidden iframe
   * Hides non-essential elements (images, buttons) during print
   */
  (function() {
    function printElement(element) {
      var iframe = document.createElement('iframe');
      iframe.style.visibility = 'hidden';
      iframe.style.position = 'fixed';
      iframe.style.right = '0';
      iframe.style.bottom = '0';
      document.body.appendChild(iframe);
  
      var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      var printCSS = [
        '@media print {',
        '  .header-container .article-recipes_left,',
        '  .article-recipes_container-video .article-recipes_left,',
        '  img, .ope-btns {',
        '    display: none !important;',
        '  }',
        '  .recipes-article-title {',
        '    font-size: 36px;',
        '    font-weight: 700;',
        '    line-height: 36px;',
        '  }',
        '  .recipes-article-desc {',
        '    font-size: 24px;',
        '    margin-bottom: 12px;',
        '    padding: 12px 0px;',
        '    border-bottom: 1px solid #333;',
        '  }',
        '  .recipes-article-detail {',
        '    display: flex;',
        '    text-align: center;',
        '    margin-bottom: 24px;',
        '  }',
        '  .detail-item {',
        '    flex: 1;',
        '  }',
        '  .detail-item:not(:last-child) {',
        '    border-right: 1px solid rgba(0, 0, 0, 0.6);',
        '  }',
        '  .detail-title {',
        '    font-size: 24px;',
        '  }',
        '  .detail-desc {',
        '    font-size: 18px;',
        '    line-height: 140%;',
        '  }',
        '  .recipes-content-title {',
        '    font-size: 24px;',
        '    font-weight: 700;',
        '    line-height: 100%;',
        '    margin-bottom: 24px;',
        '  }',
        '  .recipes-content-desc {',
        '    font-size: 18px;',
        '    line-height: 160%;',
        '  }',
        '  .recipes-article-kol {',
        '    display: none !important;',
        '  }',
        '}'
      ].join('\n');
  
      iframeDoc.open();
      iframeDoc.write('<html><head><title>Print</title>');
      iframeDoc.write('<style>' + printCSS + '</style>');
      iframeDoc.write('</head><body>');
      iframeDoc.body.appendChild(iframeDoc.adoptNode(element.cloneNode(true)));
      iframeDoc.write('</body></html>');
      iframeDoc.close();
  
      iframe.onload = function () {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(function () {
          document.body.removeChild(iframe);
        }, 100);
      };
    }
  
    var recipesPrintBtn = document.getElementById('recipes-print-btn');
    if (recipesPrintBtn) {
      recipesPrintBtn.addEventListener('click', function (e) {
        if (window.innerWidth < 769) {
          window.print();
        } else {
          var printableElement = document.getElementById('print-recipes');
          printElement(printableElement);
        }
      });
    }
  })();
  
  /* ============================================
     END: RECIPE ARTICLE - Print
     ============================================ */
  
  /* ============================================
     RECIPE ARTICLE - Share Functionality
     ============================================ */
  
  /**
   * Social media share buttons for recipe articles
   * Supports Facebook, X (Twitter), Pinterest, Instagram
   */
  (function() {
    var shareURL = encodeURIComponent(window.location.href);
    var shareText = encodeURIComponent('Check out this awesome content!');
  
    function shareMethod(element, url, dialogName) {
      if (!element) return;
      element.addEventListener('click', function (e) {
        e.preventDefault();
        window.open(url, dialogName + '-share-dialog', 'width=800,height=600');
      });
    }
  
    // Facebook
    var facebookURL = 'https://www.facebook.com/sharer/sharer.php?u=' + shareURL;
    shareMethod(document.getElementById('share-facebook'), facebookURL, 'facebook');
  
    // X (Twitter)
    var twitterURL = 'https://twitter.com/intent/tweet?url=' + shareURL + '&text=' + shareText;
    shareMethod(document.getElementById('share-x'), twitterURL, 'twitter');
  
    // Pinterest
    var pinterestURL = 'https://pinterest.com/pin/create/button/?url=' + shareURL + '&description=' + shareText;
    shareMethod(document.getElementById('share-pinterest'), pinterestURL, 'pinterest');
  
    // Instagram
    var instagramURL = 'https://www.instagram.com/share.php?url=' + shareURL;
    shareMethod(document.getElementById('share-instagram'), instagramURL, 'instagram');
  })();
  
  /* ============================================
     END: RECIPE ARTICLE - Share
     ============================================ */
  
